import DeletedAlert from './DeletedAlert';
export default DeletedAlert;
